export default "__VITE_ASSET__8JzI8cjz__"